import appConstants from "../../../../appConstants";
import {MultiSelectFilter} from "../../../dataGrid/columnFilters"

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ShipmentsEventStream,
      keyColumn: "Id",
      rowSelection: "single",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Id",
          field: "id",
          cellClass: "gridCell-leftAlign",
          minWidth: 220,
          hide: true,
        },
        {
          headerName: "Created DateTime",
          field: "createdDateTime",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_200,
          maxWidth: appConstants.columnWidth.W_200,
          filter: false,
        },
        {
          headerName: "Type",
          field: "type",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_100,
          maxWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Status",
          field: "status",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_100,
          maxWidth: appConstants.columnWidth.W_100,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Error",
          field: "error",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_150,
          tooltipField: "error",
          suppressSizeToFit: true,
          filter: false,
        },
        {
          headerName: "",
          field: "copyIcon",
          cellClass: "gridCell-leftAlign gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_50,
          maxWidth: appConstants.columnWidth.W_50,
          cellRenderer: () => '<i class="icon-copy pointer-cell" />',
          tooltipValueGetter: () => "Copy data",
          filter: false,
        },
        {
          headerName: "Data",
          minWidth: appConstants.columnWidth.W_250,
          sortable: false,
          cellClass: "gridCell-wrapText",
          valueGetter: (params) => JSON.stringify(params.data.data),
          tooltipValueGetter: (params) => JSON.stringify(params.data.data),
          filter: false,
        },
      ],
    };
  }
}
